// AI Risk Assessment — uses the buyer's Groq API key (from Settings) for narrative.
// The PWA works fully without this; the key is optional.

import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiRiskAssessment(
  clientDescription: string,
  checklist: any[],
  onStream: (chunk: string) => void
): Promise<void> {
  const system = `You are a compliance officer with 15 years AML/KYC experience. Analyze this client/scenario against FATF standards. Generate a tailored risk assessment narrative. Suggest specific enhanced measures. Reference applicable regulations. Use professional compliance language.`;
  try {
    await streamGroq({
      messages: [
        { role: 'system', content: system },
        { role: 'user', content: `Client description: ${clientDescription}\n\nChecklist items: ${checklist.slice(0, 10).map(c => c.requirement).join('\n')}\n\nGenerate a risk assessment narrative.` },
      ],
      temperature: 0.3,
      onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The core logic above works fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
